/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAzure extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAzure");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAzure.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAzure>): ServiceAccountCredentialsBaseForAzure {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAzure(), model);
        ServiceAccountCredentialsBaseForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAzure>): ServiceAccountCredentialsBaseForAzure {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAzure.newInstance(<ServiceAccountCredentialsBaseForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAzure) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAzure): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Managed Identity Client Id.
     */
    managed_identity_client_id: string;

    /**
     * Virtual Machine Id attached to the managed identity.
     */
    virtual_machine_id: string;

}
